module.exports = __webpack_public_path__ + "media/images/flags/1x1/gha-5d65e51c55e50630c2e0be8028eb7cad.svg";